<script>
import EventBus from '@/utils/event-bus';

import TransitionModal from '@/components/transition-modal.vue';

export default {
	components: {
		TransitionModal,
	},
	props: {
		modalId: {
			type: String,
			required: true,
		},
		mode: {
			type: String,
			default: 'if',
			validator: ( mode ) => [
				'if',
				'show',
			].includes( mode ),
		},
	},
	data() {
		return {
			modalOpen: false,
		};
	},
	created() {
		EventBus.$on( 'toggle:modal', this.toggleModal );
	},
	methods: {
		toggleModal( modalId ) {
			if ( modalId === this.modalId ) {
				this.modalOpen = ! this.modalOpen;
			}
		},
	},

	render( createElement ) {
		const { mode, modalId, modalOpen } = this;

		const elementData = {
			staticClass: 'fixed top-0 left-0 z-50 flex justify-center items-center w-full h-full bg-black bg-opacity-90 overflow-y-auto scrolling-touch',
			tabindex: '0',
			on: {
				keyup: ( { code } ) => {
					if ( code !== 'Escape' ) {
						return;
					}

					this.toggleModal( modalId );
				},
			},
		};

		if ( mode === 'show' ) {
			elementData.directives = [ {
				name: 'show',
				value: modalOpen,
			} ];
		}

		const modalDialog = createElement( 'div', elementData, this.$slots.default );

		return mode === 'show' || modalOpen
			? createElement( 'TransitionModal', {}, [ modalDialog ] )
			: undefined;
	},
};
</script>
